<nav class="navbar navbar-expand-lg fixed-top navbar-dark probootstrap-navbar">
  <!-- <div class="container-fluid"> -->
    <a class="navbar-brand" [routerLink]="['/']">BOCW</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div id="navbarSupportedContent" class="collapse navbar-collapse" *ngIf="userrolecode!='sewakendra'">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item"><a class="nav-link" routerLink="/inspector/dashboard" >Home</a></li>
        <li *ngIf="wrkUrer.ELRole!=undefined && wrkUrer.ELRole!=''" class="nav-item">
          <a class="nav-link" (click)="BackToELabour()" >Back To Elabour</a>
        </li>
        <li *ngIf="userrolecode == 1003" class="nav-item"><a class="nav-link" routerLink="/worker/viewfile/new/{{wrkSerialCode}}" >
          <i class="fa fa-user" aria-hidden="true"></i></a>
        </li>
        <li class="nav-item"><a class="nav-link" (click)="logout()">Logout</a></li><!-- 
        <li class="nav-item"><a class="nav-link" data-toggle="modal" data-target="#changePassword">Change Password</a></li> -->
      </ul>
    </div>
  <!-- </div> -->
</nav>
<!-- The Modal -->
<div class="modal" id="changePassword">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Change Password</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <form class="form">
          <div class="col-md-12">
            <mat-label>Enter Previous Password</mat-label>
            <mat-form-field class="full-width" appearance="outline">
              <input matInput placeholder="Enter Previous Password">
            </mat-form-field>
          </div>
          <div class="col-md-12">
              <mat-label>Enter Current Password</mat-label>
            <mat-form-field class="full-width" appearance="outline">
                <input matInput placeholder="Enter Current Password">
            </mat-form-field>
          </div>
          <div class="col-md-12">
              <mat-label>Re-enter Current Password</mat-label>
            <mat-form-field class="full-width" appearance="outline">
                <input matInput placeholder="Enter Current Password">
            </mat-form-field>
          </div>
        </form>
      </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-success" data-dismiss="modal">Submit</button>
      </div>

    </div>
  </div>
</div>
